module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loading":"Loading data...","expandMore":"Expand for more"},"es":{"loading":"Cargando...","expandMore":"Ver mas"}}')
  delete Component.options._Ctor
}
